import { lookupNumberField } from './utils';
import { OrganigrammeEntity } from './entity';
import { SHARES_PP_FIELD, SHARES_UF_FIELD, SHARES_NP_FIELD, SHARES_AT_FIELD } from '../organigramme.settings';



export class OrganigrammeEntityLink {
  entity: OrganigrammeEntity

  selected = true

  pp_shares: number
  uf_shares: number
  np_shares: number
  at_shares: number

  parseShares(object: any) {
    this.pp_shares = lookupNumberField(object, SHARES_PP_FIELD);
    this.uf_shares = lookupNumberField(object, SHARES_UF_FIELD);
    this.np_shares = lookupNumberField(object, SHARES_NP_FIELD);
    this.at_shares = lookupNumberField(object, SHARES_AT_FIELD);
  }
}